import { Box, xcss } from '@atlaskit/primitives';
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const wrapperStyles = xcss({
  display: 'flex',
  flexDirection: 'column'
});
export const CustomMenuList = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/_jsx(Box, {
    xcss: wrapperStyles,
    children: children
  });
};